import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { BackButtonService } from '../services/back-button.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslatePipe],
  template: `
    <button
      (click)="handleBack()"
      class="group flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-slate-500 bg-white border border-slate-200 rounded-lg hover:border-indigo-200 hover:text-indigo-600 hover:bg-indigo-50 transition-all shadow-sm"
    >
      <fa-icon
        [icon]="faArrowLeft"
        class="inline-block text-xs group-hover:-translate-x-0.5 rtl:group-hover:translate-x-0.5 rtl:-scale-x-100 transition-transform"
      ></fa-icon>
      <span>{{ label | translate }}</span>
    </button>
  `,
})
export class BackButton {

  @Input() label: string = 'COMMON.BACK';
  @Input() fallbackRoute: string = '';
  @Input() steps: number = 1;
  /** 'custom' skips navigation and only emits `back`, for in-page back (e.g. list → detail). */
  @Input() mode: 'simple' | 'fallback' | 'steps' | 'custom' = 'simple';

  @Output() back = new EventEmitter<void>();

  faArrowLeft = faArrowLeft;

  constructor(private backBtn: BackButtonService) {}

  handleBack(): void {
    if (this.mode === 'custom') {
      this.back.emit();
    } else if (this.mode === 'fallback' && this.fallbackRoute) {
      this.backBtn.goBackOrFallback(this.fallbackRoute);
    } else if (this.mode === 'steps') {
      this.backBtn.goBackSteps(this.steps);
    } else {
      this.backBtn.goBack();
    }
  }
}